// extracted by mini-css-extract-plugin
export default {"root":"Burger_root__QFnGN","bg":"Burger_bg__qwmcp","wrapper":"Burger_wrapper__HzUED"};